<mat-card appearance="outlined" class="settings-card">
  <mat-card-title>Settings</mat-card-title>
  <mat-card-content class="settings-content">
    <mat-checkbox [(ngModel)]="chipLabelsEnabled">Chip labels</mat-checkbox>
    <mat-checkbox [(ngModel)]="clearButtonEnabled">"Clear" Button</mat-checkbox>
    <mat-checkbox [(ngModel)]="confirmOnRemove">Confirmation on remove</mat-checkbox>
    <button mat-button (click)="toggleSet()">Use {{isUsingSetB ? 'Set A' : 'Set B'}}</button>
    <mat-form-field appearance="outline">
      <mat-label>ID Generation Strategy</mat-label>
      <mat-select [(value)]="currentStrategy" (selectionChange)="strategyUpdated.emit($event.value)">
        @for (strategy of allStrategies; track strategy) {
          <mat-option [value]="strategy">
            {{displayStrategy(strategy)}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <pre matTooltip="Current Identifier">{{currentIdentifier}}</pre>

    @if (showManualInput | async) {
      <mat-form-field class="manual-input" appearance="outline">
        <mat-label>Manual Identifier</mat-label>
        <input #manualInput matInput placeholder="cool-beans" [(ngModel)]="manualIdentifier"
               (change)="manualIdentifierUpdated.emit(manualInput.value)">
      </mat-form-field>
    }

  </mat-card-content>
</mat-card>
